import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserProfile } from "@/hooks/useUserProfile";

export function ProtectedRoute() {
  const { session, profile, loading } = useUserProfile();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-navy border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Redirect bakery partners and admins away from customer routes
  if (profile?.role === "bakery") {
    return <Navigate to="/bakery/dashboard" replace />;
  }
  if (profile?.role === "lembra_admin") {
    return <Navigate to="/admin" replace />;
  }

  const companyId = profile?.company_id ?? null;

  // If no company_id and not already on /onboarding, redirect there
  if (!companyId && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  // If has company_id and on /onboarding, redirect to dashboard
  if (companyId && location.pathname === "/onboarding") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
